import { apiClient } from '@/lib/api-client';
import type {
  CreateWorkingScheduleInput,
  EffectiveSchedule,
  Holiday,
  UpdateWorkingScheduleInput,
  WorkingSchedule,
  WorkingScheduleDetail,
} from './types';

export const workingSchedulesApi = {
  list: () => apiClient<WorkingSchedule[]>('/working-schedules'),

  get: (id: string) => apiClient<WorkingScheduleDetail>(`/working-schedules/${id}`),

  create: (input: CreateWorkingScheduleInput) =>
    apiClient<WorkingSchedule>('/working-schedules', { method: 'POST', body: input }),

  update: (id: string, input: UpdateWorkingScheduleInput) =>
    apiClient<WorkingSchedule>(`/working-schedules/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiClient<{ id: string }>(`/working-schedules/${id}`, { method: 'DELETE' }),

  addHoliday: (id: string, input: { holiday_date: string; name: string }) =>
    apiClient<Holiday>(`/working-schedules/${id}/holidays`, { method: 'POST', body: input }),

  removeHoliday: (id: string, holidayId: string) =>
    apiClient<{ id: string }>(`/working-schedules/${id}/holidays/${holidayId}`, { method: 'DELETE' }),

  /** schedule_id null = back to the country default. */
  assignLocation: (locationId: string, scheduleId: string | null) =>
    apiClient<EffectiveSchedule>('/working-schedules/locations', {
      method: 'PUT',
      body: { location_id: locationId, schedule_id: scheduleId },
    }),

  /** schedule_id null = back to the store's schedule. */
  assignUser: (userId: string, scheduleId: string | null) =>
    apiClient<{ user_id: string; schedule_id: string | null }>('/working-schedules/users', {
      method: 'PUT',
      body: { user_id: userId, schedule_id: scheduleId },
    }),

  /** The working week in force at a store — used to default a new shift's days. */
  effective: (locationId: string) =>
    apiClient<EffectiveSchedule>(`/working-schedules/effective?location_id=${encodeURIComponent(locationId)}`),
};
